import React, { useEffect, useState } from "react";
import theme from "../../../muiTheme";
import { useTranslation } from "react-i18next";
import "./DynamicPromoBanner.scss";
import { Button, Stack, Typography } from "@mui/material";
import promoImg from "../../../assets/images/PromoBanner.png";
import ButtonElement from "../ButtonElement/ButtonElement";

interface DynamicPromoBannerProps {
  text: string;
  btnText: string;
}

const DynamicPromoBanner = ({ text, btnText }: DynamicPromoBannerProps) => {
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = useState(localStorage.getItem('bannerDismissed') !== 'true');


  const dismissBanner = () => {
    localStorage.setItem(process.env.REACT_APP_LOCALSTORAGE_BANNER_DISMISSED!, 'true');
    setShowBanner(false);
  };

  useEffect(() => {
    const handleStorageChange = () => {
      setShowBanner(localStorage.getItem('bannerDismissed') !== 'true');
    };

    window.addEventListener('storage', handleStorageChange);

    // Cleanup listener
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const handleOpenHref = (href: string) => () => {
    window.open(href, '_blank');
  }

  return (
    <>
      {showBanner && (
        <Stack
          sx={{
            width: "100%",
            borderRadius: "2px",
            background: theme.palette.background.promo1,
          }}
          direction={"row"}
          marginBottom={{ xs: "48px", md: "40px" }}
        >
          <Stack className="promo-img">
            <img src={promoImg} alt="promo-banner-img" height={"100%"} />
          </Stack>
          <Stack
            direction={"column"}
            paddingX={"1.5rem"}
            paddingY={"1rem"}
            gap={"1rem"}
            flex={"1"}
          >
            <Typography
              component="h2"
              variant="h2"
              color={theme.palette.background.default}
            >
              {t(`Promo.${text}`)}
            </Typography>
            <Stack width={"11rem"} className="promo-button">
              <ButtonElement onClick={handleOpenHref('https://www.totalenergies.es/es/pymes/autoconsumo-solar') }>
                <Typography color={"white"}>{t(`Promo.${btnText}`)}</Typography>
              </ButtonElement>
            </Stack>
          </Stack>
          <Button 
            sx={{ 
              alignSelf: "flex-start", 
              justifySelf: "flex-end", 
              padding: "1rem",
              minWidth: "auto",
              "&:hover": {
                backgroundColor: "transparent",
              }
            }} 
            aria-label="close"
            onClick={() => dismissBanner()}
          >
            <Typography component="span" className="t-icon-close" sx={{ color: "white" }}></Typography>
          </Button>
        </Stack>
      )}
    </>
  );
};

export default DynamicPromoBanner;
